import { z } from "zod";

import { ColombianDocumentType, TransfiyaAccountType } from "../../services/paymentsPayout.service";

export const TRANSFIYA_ACCOUNT_TYPES = Object.values(TransfiyaAccountType) as [
  TransfiyaAccountType,
  ...TransfiyaAccountType[],
];
export const TRANSFIYA_DOCUMENT_TYPES = Object.values(ColombianDocumentType) as [
  ColombianDocumentType,
  ...ColombianDocumentType[],
];

export interface TransfiyaFormMessages {
  bank: string;
  accountNumber: string;
  name: string;
  documentNumber: string;
}

/** Mirrors the runtime's Transfiya destination rules; messages are injected so it stays testable. */
export function transfiyaRecipientSchema(messages: TransfiyaFormMessages) {
  return z.object({
    bankCode: z.string().min(1, messages.bank),
    accountType: z.enum(TRANSFIYA_ACCOUNT_TYPES),
    accountNumber: z.string().regex(/^\d{4,34}$/, messages.accountNumber),
    beneficiaryName: z.string().trim().min(2, messages.name).max(120, messages.name),
    documentType: z.enum(TRANSFIYA_DOCUMENT_TYPES),
    documentNumber: z.string().regex(/^\d{4,20}$/, messages.documentNumber),
  });
}

export type TransfiyaRecipientValues = z.input<ReturnType<typeof transfiyaRecipientSchema>>;

export const EMPTY_TRANSFIYA_VALUES: TransfiyaRecipientValues = {
  bankCode: "",
  accountType: TransfiyaAccountType.SAVINGS,
  accountNumber: "",
  beneficiaryName: "",
  documentType: ColombianDocumentType.CC,
  documentNumber: "",
};
